import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { LgAuthService } from '@shared/services/auth.service';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { BazisModalService } from '@bazis/shared/services/modal.service';
import { TranslocoModule } from '@jsverse/transloco';
import { OnboardingService } from '@pages/shared/services/onboarding.service';

@Component({
    selector: 'app-modal-end-onboarding',
    templateUrl: './modal-end-onboarding.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ButtonModule, TranslocoModule, ColorDirective],
})
export class ModalEndOnboardingComponent {
    constructor(
        private modalService: BazisModalService,
        private onboardingService: OnboardingService,
        protected router: Router,
        private authService: LgAuthService,
    ) {}

    closeModal() {
        this.modalService.dismiss();
        this.onboardingService.hide();
        this.router.navigateByUrl('routes/plannings');
        this.authService.setOnboardingViewed();
    }
}
